export default "__VITE_ASSET__BkKL8FAT__"